// @ts-nocheck
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const DEFAULT_CONTEXT = {
  tier: 'OPERATIONAL',
  jurisdictionKey: 'UNKNOWN',
  countryCode: null,
  regionCode: null,
  allow_platform_fees: true,
  allow_fiat_onramp: true,
  platform_fee_usdc_flat: 0.5,
  loading: true,
};

const ComplianceContext = createContext(DEFAULT_CONTEXT);

/** Only reached in OPERATIONAL jurisdictions — BLOCKED requests never render the React tree. */
export const ComplianceProvider = ({ children, initialContext = null }) => {
  const [state, setState] = useState(() =>
    initialContext
      ? { ...initialContext, loading: false }
      : DEFAULT_CONTEXT
  );

  useEffect(() => {
    if (initialContext) {
      return undefined;
    }

    let cancelled = false;

    const load = async () => {
      try {
        const response = await fetch('/api/compliance/context', { credentials: 'same-origin' });
        if (!response.ok) {
          throw new Error('Compliance context unavailable');
        }
        const payload = await response.json();
        if (!cancelled) {
          setState({ ...payload, loading: false });
        }
      } catch {
        if (!cancelled) {
          setState(prev => ({ ...prev, loading: false }));
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [initialContext]);

  const value = useMemo(
    () => ({
      ...state,
      isOperational: state.tier === 'OPERATIONAL',
    }),
    [state]
  );

  return <ComplianceContext.Provider value={value}>{children}</ComplianceContext.Provider>;
};

export const useCompliance = () => useContext(ComplianceContext);

export default ComplianceContext;
